import { LocalService } from './../../../services/storage/localService';
import { FacturacionCPEService } from './../../../services/facturacion-cpe/facturacion-cpe.service';
import { CpeDetalle } from './../../../models/cpeDetalle';
import { FormGroup,FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';



@Component({
  selector: 'app-detalle-cpe',
  templateUrl: './detalle-cpe.component.html',
  styleUrls: ['./detalle-cpe.component.scss']
})
export class DetalleCpeComponent implements OnInit {

  readonly IGV_Porcentaje = this.localService.getJsonValue('ParametroIGVPorcentaje');
  @Output() itemDetalle = new EventEmitter();
  form: FormGroup;
  ItemCombo : any = [];
  ItemArray : any = [];
  Cantidad : number;
  Valor_Unitario : number;
  Descripcion: any;
  Unidad_Medida:any;
  cpeDetalle = new CpeDetalle();
  dataCPETipo:any;
  tipoFacturacionElement;

  @Output() cerrarDetalle = new EventEmitter<boolean>();

  constructor(private cpeService : FacturacionCPEService,private localService : LocalService) {
    this.form = new FormGroup({
      ProductoServicio: new FormControl('', Validators.required),
      Descripcion: new FormControl(this.cpeDetalle.Descripcion, [Validators.required]),
      Cantidad:new FormControl(1, Validators.required),
      Valor_Unitario:new FormControl(0, [Validators.required,Validators.pattern("[0-9.]+$")]),
     });
   }

  ngOnInit() {
    this.ItemCombo = this.cpeService.Productos;
  }

  CerrarPopUp() {
    this.cerrarDetalle.emit();
  }

  Add(){
    this.cpeDetalle.Unidad_Medida = "UNIDAD";
    this.Calcular();
    this.itemDetalle.emit(this.cpeDetalle);
    this.cerrarDetalle.emit();
  }
  
  SetearItem(idProducto){
    if(this.ItemCombo.length > 0){
      this.ItemArray = this.ItemCombo.filter(
        state => state.idProducto == idProducto
      );
      this.cpeDetalle.Codigo_Producto = this.ItemArray[0].idProducto;
      this.cpeDetalle.Descripcion = this.ItemArray[0].Descripcion;
      this.cpeDetalle.Unidad_Medida = this.ItemArray[0].Unidad_Medida;
      this.cpeDetalle.Valor_Unitario = this.ItemArray[0].Precio;
      this.form.controls['Valor_Unitario'].setValue(this.cpeDetalle.Valor_Unitario); 
      this.form.controls['Descripcion'].setValue(this.cpeDetalle.Descripcion); 
    }
  }
  Calcular(){
      this.cpeDetalle.Valor_Venta =  Math.round((this.cpeDetalle.Cantidad * this.cpeDetalle.Valor_Unitario)*100)/100; 
      this.cpeDetalle.IGV_Importe = Math.round((this.cpeDetalle.Valor_Venta * this.cpeDetalle.IGV_Porcentaje)*100)/100;
      this.cpeDetalle.Precio_Venta = this.cpeDetalle.Valor_Venta + this.cpeDetalle.IGV_Importe;
      this.cpeDetalle.SubTotal = this.cpeDetalle.Valor_Venta;
      this.cpeDetalle.Total = this.cpeDetalle.Precio_Venta;
      this.cpeDetalle.Valor_Unitario_IGV = Math.round((this.cpeDetalle.Valor_Unitario * (1+Number(this.cpeDetalle.IGV_Porcentaje)))*100)/100;     
  }
  
  cambiarValor( valor: number ) {
    if (this.cpeDetalle.Cantidad == null) {
      this.cpeDetalle.Cantidad = 1;
      return;
    }
    if (this.cpeDetalle.Cantidad <= 1 && valor < 1) {
      this.cpeDetalle.Cantidad = 1;
        return;
    }
    this.cpeDetalle.Cantidad = this.cpeDetalle.Cantidad + valor ;


  }

  tipoServicio(event){    
    this.dataCPETipo = event.split("|");
    this.cpeDetalle.Codigo_Tributo = this.dataCPETipo[0];
    this.cpeDetalle.IGV_Afectacion = this.dataCPETipo[1];
    this.cpeDetalle.IGV_Porcentaje = this.dataCPETipo[2];
  }

}





